import * as React from "react";
import { useState } from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { Table } from "../../../../../../../Shared/Table/Table";
import { Contents } from "../../Insights/Resource/Contents";
import { OffPlatformIncomesCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/OffPlatformIncomesCollection";

interface IOffPlatformIncomeProps {
    data: OffPlatformIncomesCollection;
    onTableChange: (minrow, maxrow) => void;
}

export const OffPlatformIncome = (props: IOffPlatformIncomeProps) => {
    if (!props.data) {return null;}

    const [currentPage, setCurPage] = useState(1);

    const getData = (currentPage) => {
        const minrow = (currentPage - 1) * 10 + 1;
        const maxrow = currentPage * 10;
        props.onTableChange(minrow, maxrow);
    };

    const getMoneyFormat = (val: number): string => {
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), CurrencyCode.GBP);
        if (val < 0) {
            formatMoney = "-" + formatMoney;
        }
        return formatMoney;
    };

    return props.data && props.data.OffPlatformIncomes.length < 1 ? (
        <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessage} />
    ) : (
        <div className="pt-24">
            <div className="mb-50">
                <Table
                    data={props.data.OffPlatformIncomes}
                    col={[
                        {
                            title: "Id",
                            key: "ExternalAssetIncomeSummaryId",
                        },
                        {
                            title: "Payment date",
                            key: "DateCreated",
                            thCssWrapper: "ctable-sort",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                            }
                        },
                        {
                            title: "Instrument code",
                            key: "InvestmentCode",
                        },
                        {
                            title: "Investments",
                            key: "InvestmentName",
                        },
                        {
                            title: "Amount",
                            key: "Amount",
                            thCssWrapper: "ctable-sort cell-right",
                            tdCssWrapper: "cell-right",
                            render: (data, row, index) => {
                                return getMoneyFormat(data);
                            }
                        },
                    ]}
                    // TotalBody={[
                    //     { data: "Total", colSpan: 4 },
                    //     {
                    //         data: getMoneyFormat(
                    //             props.data.OffPlatformIncomes.reduce((total, ele) => {
                    //                 return total + ele.Amount;
                    //             }, 0)
                    //         ),
                    //         tfTdCssWrapper: "cell-right",
                    //     },
                    // ]}
                    needPagination={{
                        totalNumOfResult: props.data.TotalRows,
                        currentPage: currentPage,
                        onPaginationChange: (pageIndex, pageSize) => {
                            setCurPage(pageIndex);
                            getData(
                                pageIndex
                            );
                        },
                    }}
                />
            </div>
        </div>
    );
};
